import React from "react";
import {format} from 'date-fns';
import {Placeholder} from "../../placeholder";
import {Pager} from "./pager";
import $ from "jquery";

export class Reviews extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			reviews: [{}, {}, {}],
			count: 0,
			page: 0,
			loading: false,
		};
	}

	componentDidMount() {
		this.reloadReviews();
	}

	reloadReviews() {
		this.setState({loading: true}, () => {
			$.ajax(this.props.source, {
				method: 'get',
				data: {page: this.state.page},
				dataType: 'json',
				success: ({reviews, count}) => this.setState({reviews: Array.isArray(reviews) ? reviews : [], count}),
				error: () => this.setState({reviews: null}),
				complete: () => this.setState({loading: false})
			});
		});
	}

	setPage(page) {
		this.setState({page, reviews: [{}, {}, {}]}, () => this.reloadReviews())
	}

	render() {
		return (
			<div className="reviews">
				{this.state.count > 0 && <div className="spacer" />}

				{this.state.reviews.map(review => (
					<div className="review">
						<div className="row">
							<div className="col-md-2 review-pane-left">
								<div className="user">
									<Placeholder watch={review.name} content="Von Jane Doe" width="content">Von {review.name}</Placeholder>
								</div>
								<div className="date">
									<Placeholder watch={review.timestamp} content="Am 01.01.2000 veröffentlicht" width="content">Am {format(new Date(review.timestamp), 'DD.MM.YYYY')} veröffentlicht</Placeholder>
								</div>
								{review.avatar &&
									<div className="gravatar">
										<img src={`https://www.gravatar.com/avatar/${review.avatar}?s=64&d=identicon`} alt="Gravatar"/>
									</div>
								}
							</div>
							<div className="col-md-10 review-pane-right">
								<h3 className="title">
									<Placeholder watch={review.title} width="5">
										<span className="rating">
											<span className="layers">
												<span className="layer2">
													{[0, 1, 2, 3, 4].map(n => {
														if(review.rating > n + .5) {
															return <i className="fa fa-star" />;
														} else if (review.rating > n) {
															return <i className="fa fa-star-half" />;
														}
														return null;
													})}
												</span>
												<span className="layer1">
													{[0, 1, 2, 3, 4].map(() => <i className="fa fa-star" />)}
												</span>
											</span>
										</span>
										{' '}
										<span className="title">{review.title}</span>
									</Placeholder>
								</h3>
								<p className="text">
									<Placeholder watch={review.text} content={<div>&nbsp;<br />&nbsp;<br />&nbsp;<br />&nbsp;</div>} width="12">{review.text}</Placeholder>
								</p>
							</div>
						</div>

						<div className="spacer-2" />
					</div>
				))}

				{this.state.count > 0 && <div className="spacer" />}

				<Pager disabled={this.state.loading} page={this.state.page} count={this.state.count} perPage={10} onChange={p => this.setPage(p)} href={`#product-reviews-widget`} />

				{this.state.count > 0 && <div className="spacer-2" />}

				{this.state.count < 1 &&
					<div>
						<p>Bislang wurden noch keine Bewertungen veröffentlicht.</p>
						<p>Sagen Sie anderen Nutzern, was Sie von diesem Produkt halten!</p>
						<div className="spacer-2" />
					</div>
				}
			</div>
		);
	}
}
